import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DeliverySlot, DeliverySlotGroupByDate } from '@delivery/const';
import { DeliveryCalculatorFormService, DeliverySlotsService } from '@delivery/feature';
import { Observable, Subscription } from 'rxjs';
import { debounceTime, map, switchMap, take, tap, withLatestFrom } from 'rxjs/operators';

@Component({
  selector: 'ui-delivery-calculator-results-modal',
  templateUrl: './delivery-calculator-results-modal.component.html',
  styleUrls: ['./delivery-calculator-results-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DeliveryCalculatorResultsModalComponent implements OnInit, OnDestroy {
  deliverySlots$: Observable<DeliverySlotGroupByDate[]>;
  currentPrice$: Observable<number>;
  loading$: Observable<boolean>;

  formSlot = new FormControl();

  private subscription = new Subscription();

  constructor(
    private deliverySlotsService: DeliverySlotsService,
    public deliveryCalculatorFormService: DeliveryCalculatorFormService,
  ) {}

  ngOnInit(): void {
    this.deliverySlots$ = this.deliverySlotsService.getDeliverySlotsGroupByDate();

    this.currentPrice$ = this.deliverySlots$.pipe(
      take(1),
      tap((deliverySlots: DeliverySlotGroupByDate[]) => {
        if (deliverySlots.length) {
          const firstSlotId: string = this.getFirstSlotId(deliverySlots);
          this.formSlot.setValue(firstSlotId);
        }
      }),
      withLatestFrom(this.formSlot.valueChanges),
      switchMap(([, slotId]) => this.getSlotById(slotId).pipe(map((slot) => slot?.price))),
    );

    this.subscription.add(
      this.deliveryCalculatorFormService.form
        .get('weight')
        .valueChanges.pipe(debounceTime(1000))
        .subscribe(() => {
          this.deliveryCalculatorFormService.onSubmit();
        }),
    );
    this.loading$ = this.deliverySlotsService.getDeliverySlotsLoading();
  }

  getSlotId(dnd: number, index: number): string {
    return [dnd, index].join('_');
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private getFirstSlotId(deliverySlots: DeliverySlotGroupByDate[]): string {
    const dnd = Object.keys(deliverySlots)[0];

    return this.getSlotId(Number(dnd), 0);
  }

  private getSlotById(id: string): Observable<DeliverySlot> {
    const [dnd, index] = id.split('_').map(Number);

    return this.deliverySlots$.pipe(map((deliverySlots) => deliverySlots[dnd]?.slots[index]));
  }
}
